import React from 'react';
import { DatePicker, Form, InputNumber, Select } from "antd";
import { useDeliveryChannels } from "../../hooks/useDeliveryChannels";
import dayjs from "dayjs";
import { SectionCard } from "./orderFormShared";

const { Option } = Select;

const chargeFormatter = (value) =>
  value === undefined || value === null || value === ''
    ? ''
    : `৳ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
const chargeParser = (value) => (value || '').replace(/[৳,\s]/g, '');

const DeliveryFrom = () => {
  const { deliveryChannels } = useDeliveryChannels();

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().endOf('day');
  };

  return (
    <SectionCard
      id="et-of-section-delivery"
      title="Delivery & billing"
      subtitle="Charge is added to the grand total"
    >
      <div className="et-of-cols3">
        <Form.Item
          name="deliveryChannel"
          label="Delivery channel"
          rules={[{ required: true, message: 'Please select delivery channel!' }]}
        >
          <Select placeholder="Select courier">
            {deliveryChannels.map((data) => (
              <Option value={data.id} key={data.id}>{data.name}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="deliveryDate"
          label="Delivery date"
          rules={[{ required: true, message: 'Please input delivery Date!' }]}
        >
          <DatePicker
            format="YYYY-MM-DD"
            placeholder="YYYY-MM-DD"
            disabledDate={disabledDate}
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          name="deliveryCharge"
          label="Delivery charge"
          rules={[{ required: true, message: 'Please input valid delivery charge!' }]}
        >
          <InputNumber
            min={0}
            controls={false}
            placeholder="৳ 0"
            formatter={chargeFormatter}
            parser={chargeParser}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </div>
    </SectionCard>
  );
};

export default DeliveryFrom;
